import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getStoredToken } from '../services/token.storage';

/**
 * Garde d'authentification : redirige vers /login si aucun JWT n'est stocké.
 * Ne simule aucune vérification : la validité du token est contrôlée par le
 * backend (l'intercepteur laisse passer les requêtes, le serveur les rejette).
 */
export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (getStoredToken()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
